import { FunctionComponent } from "react";
import ApolloPage from "../../components/ApolloPage/ApolloPage";
import { InProgressPage } from "@fyrstain/hl7-front-library";
import { Title } from "@fyrstain/fhir-front-library";
import i18n from "i18next";
import { toPublicUrl } from "../../services/PublicUrl";

const InProgress: FunctionComponent = () => {

    return <ApolloPage loading={false} needsLogin={false} >
        <InProgressPage
            heading={
                <Title
                    level={1}
                    prefix={i18n.t('status.inProgress.prefix')}
                    content={i18n.t('status.inProgress.content')}
                />
            }
            illustration={<img src={toPublicUrl("/assets/InProgress.png")} alt="" />}
        />
    </ApolloPage>
};

export default InProgress;
